const $s = globalThis.$s;

function initWelcomePopup() {
  const welcomePopup = document.querySelector(".welcome-popup");
  if (welcomePopup === null) {
    return;
  }
  if (globalThis.sessionStorage.getItem("homepageVisited") === "true") {
    welcomePopup.remove();
    return;
  }
  welcomePopup.classList.remove("hide");
}

function initPageShowOverlay(/** @type {PageTransitionEvent} */ event) {
  if (event.persisted) {
    $s.hideLoadingOverlay();
  }
}

function initRewriteLinks() {
  const skipHosts = new Set(["pendulumlife.com", "127.0.0.1:9292"]);
  const links = Array.from(document.links);
  for (const link of links) {
    if (link.host !== location.host && !skipHosts.has(link.host)) {
      link.target = "_blank";
    }
  }
}

function initEmailConfirmContainer() {
  if (!globalThis.location.href.includes("account/subscribe")) {
    return;
  }
  /** @type {HTMLElement | null} */
  const container = document.querySelector(".shopify-email-marketing-confirmation__container");
  if (container === null) {
    return;
  }
  /** @type {NodeListOf<HTMLParagraphElement>} */
  const pContainers = container.querySelectorAll("p");
  if (pContainers.length > 0) {
    pContainers[0].innerHTML = '<span style="font-size:28px;">Thank you for verifying your email address.</span>';
    if (pContainers.length > 1) {
      pContainers[1].classList.add("hide");
    }
  }
  /** @type {HTMLAnchorElement | null} */
  const oldLink = container.querySelector("a");
  if (oldLink !== null) {
    oldLink.classList.remove("hide");
    const newLink = document.createElement("a");
    newLink.href = "https://pendulumlife.com/#featured-products";
    // Set the link text
    newLink.textContent = "Shop now";
    // Add the 'btn' class
    newLink.className = "btn";
    // Replace the old <a> element with the new one
    if (oldLink.parentNode !== null) {
      oldLink.parentNode.replaceChild(newLink, oldLink);
    }
    newLink.style.marginTop = "24px";
  }
  container.style.padding = "10% var(--container-padding)";
  container.style.textAlign = "center";
}

function initDiscountCookie() {
  const setAffiliateDiscountCookie = (/** @type {string} */ discountCode) => {
    const days = 1;
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${expiryDate.toUTCString()}`;
    globalThis.document.cookie = `affiliateDiscount=${discountCode};${expires};path=/`;
  };
  const referrer = globalThis.document.referrer;
  if (referrer.includes("utm_content=5775525") || globalThis.location.search.includes("nathalie")) {
    setAffiliateDiscountCookie("NIDDAM");
  }
  if (globalThis.location.search.includes("asprey")) {
    setAffiliateDiscountCookie("ASPREY20");
  }
}

function initAddProductWithDiscountFromURL() {
  const urlParams = new URLSearchParams(globalThis.location.search);
  const variantId = urlParams.get("promoVariantId");
  const discountCode = urlParams.get("promoDiscountCode");
  if (variantId === "" || variantId === null || discountCode === "" || discountCode === null) {
    return;
  }
  const xhr = new XMLHttpRequest();
  xhr.open("POST", "/cart/add.js", true);
  xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
  xhr.onload = () => {
    if (xhr.status !== 200) {
      console.error("There was an error adding the product to the cart.");
      return;
    }
    // biome-ignore lint/suspicious/noConsole: Since this is a global redirect this is a good place for a message
    console.log("Redirecting to the discount page (1)");
    globalThis.location.href = `/discount/${discountCode}`;
  };
  xhr.send(`quantity=1&id=${variantId}`);
}

function initUtmMediumRedirect() {
  const marketingUrlParams = new URLSearchParams(globalThis.location.search);
  const utmMedium = marketingUrlParams.get("utm_medium");
  if (utmMedium === "katiecouric") {
    globalThis.location.replace("https://www.dpbolvw.net/click-100797589-15048681?sid=WUC10%2F3%2F23");
  }
}

function initSkipToContentLink() {
  /** @type {HTMLAnchorElement | null} */
  const skipLink = globalThis.document.querySelector(".skip-to-content-link");
  if (skipLink === null) {
    return;
  }
  const focusSkipTarget = () => {
    const targetId = skipLink.hash.replace("#", "");
    if (targetId === "") {
      return;
    }
    const target = globalThis.document.getElementById(targetId);
    if (target === null) {
      return;
    }
    target.setAttribute("tabindex", "-1");
    target.focus();
    target.scrollIntoView();
    if (globalThis.location.hash !== skipLink.hash) {
      globalThis.history.pushState(null, "", skipLink.hash);
    }
  };
  /** @param {Event} event */
  const handleActivation = (event) => {
    event.preventDefault();
    focusSkipTarget();
  };
  skipLink.addEventListener("click", handleActivation);
  skipLink.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }
    handleActivation(event);
  });
}

/** @type {Map<string, string>} */
const generatedImageAltText = new Map([
  ["img.r-5ky2vi:not([alt])", "Pendulum Metabolic Daily product packaging."],
  ["img.r-1uzlh24:not([alt])", "Pendulum Metabolic Daily Bundle product packaging."],
  ["img.r-1icbcm6:not([alt])", "Pendulum Gut Fuel Pouch product packaging."],
  ["img.r-ni99cq:not([alt])", "Pendulum Gut Fuel Packets product packaging."],
  ["img.r-9n6745:not([alt])", "Pendulum Metabolic Daily product packaging."],
  ["img.r-2qhek1:not([alt])", "Pendulum Akkermansia product packaging."],
  ["img.r-8hes17:not([alt])", "Pendulum Polyphenol Booster product packaging."],
]);

const ignoredGeneratedTextLabels = new Set(["Add To Cart", "Bestseller", "Learn More", "Single Strain", "other thing"]);

const generatedContentSelector = [
  "[data-rid]",
  "[data-replo-component-root]",
  "[data-replo-product-container]",
  "[data-alchemy-element-mount-node]",
  ".alchemy__element",
].join(",");

/** @param {Element} element */
const isGeneratedContentElement = (element) => element.closest(generatedContentSelector) !== null;

/** @param {string} value */
const normalizeLabel = (value) => value.replace(/\s+/g, " ").trim();

/**
 * @param {ParentNode} root
 * @param {string} selector
 */
const queryAllIncludingRoot = (root, selector) => [
  ...(root instanceof Element && root.matches(selector) ? [root] : []),
  ...root.querySelectorAll(selector),
];

/** @param {string} value */
const titleFromHandle = (value) =>
  value
    .split("?")[0]
    .split("#")[0]
    .split("/")
    .filter(Boolean)
    .pop()
    ?.split("-")
    .filter(Boolean)
    .map((part) => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join(" ") ?? "";

/** @param {HTMLAnchorElement} link */
const getLabelFromLink = (link) => {
  const existingLabel = normalizeLabel(link.textContent ?? "");
  if (existingLabel !== "") {
    return existingLabel;
  }
  return titleFromHandle(link.getAttribute("href") ?? "");
};

/** @param {HTMLAnchorElement} link */
const linkHasAccessibleName = (link) => {
  if (normalizeLabel(link.textContent ?? "") !== "") {
    return true;
  }
  const images = link.querySelectorAll("img[alt]");
  for (const image of images) {
    if (normalizeLabel(image.getAttribute("alt") ?? "") !== "") {
      return true;
    }
  }
  return false;
};

/**
 * @param {Element} element
 * @param {number} depth
 * @returns {Element[]}
 */
const getAncestorChain = (element, depth = 0) => {
  if (element.parentElement === null || depth >= 8) {
    return [];
  }
  return [element.parentElement, ...getAncestorChain(element.parentElement, depth + 1)];
};

/** @param {string} label */
const isUsefulGeneratedTextLabel = (label) =>
  label !== "" && label.length <= 80 && !ignoredGeneratedTextLabels.has(label);

/** @param {HTMLImageElement} image */
const getGeneratedTextLabel = (image) => {
  for (const ancestor of getAncestorChain(image)) {
    const labelElements = ancestor.querySelectorAll("h1,h2,h3,.alchemy-rte");
    for (const labelElement of labelElements) {
      const label = normalizeLabel(labelElement.textContent ?? "");
      if (isUsefulGeneratedTextLabel(label)) {
        return label;
      }
    }
  }
  return "";
};

/** @param {HTMLImageElement} image */
const getGeneratedImageAltText = (image) => {
  for (const [selector, altText] of generatedImageAltText) {
    if (image.matches(selector)) {
      return altText;
    }
  }
  const productContainer = image.closest("[data-replo-product-handle]");
  if (productContainer instanceof HTMLElement) {
    const productHandleLabel = titleFromHandle(productContainer.dataset.reploProductHandle ?? "");
    if (productHandleLabel !== "") {
      return productHandleLabel;
    }
  }
  const link = image.closest("a[href]");
  if (link instanceof HTMLAnchorElement) {
    const linkLabel = getLabelFromLink(link);
    if (linkLabel !== "") {
      return linkLabel;
    }
  }
  const textLabel = getGeneratedTextLabel(image);
  if (textLabel !== "") {
    return textLabel;
  }
  return "";
};

/** @param {ParentNode} root */
const patchGeneratedContentAccessibility = (root) => {
  for (const [selector, altText] of generatedImageAltText) {
    const images = queryAllIncludingRoot(root, selector);
    for (const image of images) {
      image.setAttribute("alt", altText);
    }
  }

  const generatedImages = queryAllIncludingRoot(root, "img:not([alt])");
  for (const image of generatedImages) {
    if (image instanceof HTMLImageElement && isGeneratedContentElement(image)) {
      image.setAttribute("alt", getGeneratedImageAltText(image));
    }
  }

  const generatedLinks = queryAllIncludingRoot(root, "a[href]");
  for (const link of generatedLinks) {
    if (
      !(link instanceof HTMLAnchorElement) ||
      !isGeneratedContentElement(link) ||
      link.hasAttribute("aria-label") ||
      link.hasAttribute("aria-labelledby") ||
      linkHasAccessibleName(link)
    ) {
      continue;
    }
    const label = titleFromHandle(link.getAttribute("href") ?? "");
    if (label !== "") {
      link.setAttribute("aria-label", label);
    }
  }

  const scrollableRegions = queryAllIncludingRoot(root, ".r-1lxxme1");
  for (const region of scrollableRegions) {
    if (!region.hasAttribute("tabindex")) {
      region.setAttribute("tabindex", "0");
    }
  }
};

function initGeneratedContentAccessibilityPatches() {
  patchGeneratedContentAccessibility(globalThis.document);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof HTMLElement) {
          patchGeneratedContentAccessibility(node);
        }
      }
    }
  });
  observer.observe(globalThis.document.body, { childList: true, subtree: true });

  globalThis.document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof HTMLElement) {
      patchGeneratedContentAccessibility(event.target);
    }
  });
}

function initImmediateActions() {
  initDiscountCookie();
  initAddProductWithDiscountFromURL();
  initUtmMediumRedirect();
}

function initPageShowActions() {
  globalThis.addEventListener(
    "pageshow",
    (event) => {
      initPageShowOverlay(event);
    },
    false,
  );
}

function initContentLoadedActions() {
  globalThis.document.addEventListener("DOMContentLoaded", () => {
    initWelcomePopup();
    initRewriteLinks();
    initEmailConfirmContainer();
    initSkipToContentLink();
    initGeneratedContentAccessibilityPatches();
    initHideVideoControlsOnMobile();
  });
}

(function init() {
  initImmediateActions();
  initPageShowActions();
  initContentLoadedActions();
})();

export {};

/**
 * Hide native controls for autoplay videos on mobile until user interaction.
 * Applies to any <video autoplay> present at load or injected later.
 */
function initHideVideoControlsOnMobile() {
  try {
    const bp = globalThis.breakpoints || { small: "768px" };
    const isMobile = globalThis.matchMedia
      ? globalThis.matchMedia(`(max-width: ${bp.small})`).matches
      : (globalThis.innerWidth || 0) <= 768;
    if (!isMobile) {
      return;
    }

    /** Track processed videos without mutating DOM attributes. */
    /** @type {WeakSet<HTMLVideoElement>} */
    const processed = new WeakSet();

    /** @param {HTMLVideoElement} vid */
    const processVideo = (vid) => {
      if (!vid || processed.has(vid)) {
        return;
      }
      // Only target autoplaying videos to match the request.
      if (!vid.hasAttribute("autoplay")) {
        return;
      }

      processed.add(vid);

      // Ensure controls start hidden on mobile.
      if (vid.controls) {
        vid.controls = false;
      }
    };

    // Initial pass (only autoplay videos)
    document.querySelectorAll("video[autoplay]").forEach((el) => {
      processVideo(/** @type {HTMLVideoElement} */ (el));
    });

    // Use delegated interaction handlers to avoid per-video listeners.
    /** @param {Event} ev */
    const onGlobalInteract = (ev) => {
      const t = /** @type {EventTarget | null} */ (ev.target);
      if (t && t instanceof HTMLVideoElement && t.hasAttribute("autoplay")) {
        t.controls = true;
      }
    };
    document.addEventListener("touchstart", onGlobalInteract, { passive: true });
    document.addEventListener("click", onGlobalInteract);

    // Watch for dynamically added videos (e.g., image_text_v2)
    const pending = new Set();
    let scheduled = false;
    const flush = () => {
      scheduled = false;
      if (pending.size === 0) {
        return;
      }
      for (const v of pending) {
        processVideo(v);
      }
      pending.clear();
    };
    const scheduleFlush = () => {
      if (scheduled) {
        return;
      }
      scheduled = true;
      // Prefer microtask to keep UI responsive during bursts.
      queueMicrotask(flush);
    };
    const observer = new MutationObserver((mutations) => {
      let found = false;
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (!(n instanceof HTMLElement)) {
            continue;
          }
          if (n.tagName && n.tagName.toLowerCase() === "video") {
            const el = /** @type {HTMLVideoElement} */ (n);
            if (el.hasAttribute("autoplay")) {
              pending.add(el);
              found = true;
            }
          } else if (n.querySelectorAll) {
            n.querySelectorAll("video[autoplay]").forEach((el) => {
              pending.add(/** @type {HTMLVideoElement} */ (el));
              found = true;
            });
          }
        }
      }
      if (found) {
        scheduleFlush();
      }
    });
    // Observe a narrower root to minimize overhead.
    const observerRoot = document.getElementById("MainContent") || document.querySelector("main") || document.body;
    observer.observe(observerRoot, { childList: true, subtree: true });

    // Additionally, hook into Shopify section load events (Theme Editor)
    // to process videos without relying only on a global observer.
    document.addEventListener("shopify:section:load", (ev) => {
      const target = /** @type {HTMLElement} */ (ev.target);
      if (target && target.querySelectorAll) {
        target.querySelectorAll("video[autoplay]").forEach((el) => {
          processVideo(/** @type {HTMLVideoElement} */ (el));
        });
      }
    });
  } catch (e) {
    // Fail silently to avoid impacting page load
    // biome-ignore lint/suspicious/noConsole: minimal logging
    console.warn("initHideVideoControlsOnMobile error", e);
  }
}
